// If you use helper for mimicking <a/> behaviour,
// please add tabIndex={0} and aria-label to the element.
// Remember to remove the outline & add a focus state if applicable.
export function handleKeyDown(e, keys: string[] = ['Enter', ' '], callback) {
    if (keys.includes(e.key)) {
        e.preventDefault();
        callback();
    }
}
